<script setup lang="ts">
  import { useAuthStore } from '@/stores/auth'
  import FrontPagePrivateView from '@/components/FrontPagePrivate.vue'
  import PublicFrontPageView from '@/components/FrontPagePublic.vue'
  import VgsSpinner from '@/components/common/VgsSpinner.vue'

  const auth = useAuthStore()
</script>

<template>
  <vgs-spinner
    v-if="auth.isLoading"
    :is-loading="auth.isLoading"
  />
  <FrontPagePrivateView v-else-if="auth.isAuthenticated" />
  <PublicFrontPageView v-else />
</template>
